module.exports = __webpack_public_path__ + "static/img/cont32_01.8001513.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont32_01.jpg
// module id = TCY4
// module chunks = 0